var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUpwardGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9913 39.9996C23.5638 39.9996 23.2084 39.8559 22.9251 39.5684C22.6418 39.2809 22.5001 38.9246 22.5001 38.4996V13.6996L11.1501 25.0496C10.8568 25.3496 10.5084 25.4996 10.1051 25.4996C9.70176 25.4996 9.3501 25.3496 9.0501 25.0496C8.7501 24.7496 8.6001 24.3996 8.6001 23.9996C8.6001 23.5996 8.7501 23.2496 9.0501 22.9496L22.9501 9.04961C23.1101 8.88598 23.2834 8.77006 23.4701 8.70186C23.6568 8.63369 23.8404 8.59961 24.021 8.59961C24.2017 8.59961 24.3767 8.63294 24.546 8.69961C24.7154 8.76628 24.8834 8.88294 25.0501 9.04961L38.9501 22.9496C39.2501 23.2496 39.4001 23.5996 39.4001 23.9996C39.4001 24.3996 39.2527 24.7496 38.958 25.0496C38.6633 25.3496 38.3133 25.4996 37.908 25.4996C37.5027 25.4996 37.1501 25.3496 36.8501 25.0496L25.5001 13.6996V38.4996C25.5001 38.9246 25.3555 39.2809 25.0663 39.5684C24.7771 39.8559 24.4188 39.9996 23.9913 39.9996Z",
    fill: "#047857"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpwardGreen);
export default __webpack_public_path__ + "static/media/arrow_upward_green.37560d8250514fff2b3126ff37f409b4.svg";
export { ForwardRef as ReactComponent };